import { companyAddress, companyName } from '@edgvr-front/companies/domain';
import { dataAccountId } from './dataAccountId';
import { nullableDataAccountRegion } from './dataAccountRegion';

export const dataAccountInfo = {
  type: 'object',
  required: ['AccountID', 'Company', 'Address'],
  properties: {
    AccountID: dataAccountId,
    Company: companyName,
    Address: companyAddress,
    Region: nullableDataAccountRegion,
  },
};
